<app-file-uploader-base
  [items]="baseItems"
  [multiple]="multiple"
  [accept]="accept"
  [disabled]="disabled"
  [viewMode]="viewMode"
  [isUploading]="isUploading"
  [errorMessage]="errorMessage"
  [label]="label"
  [hint]="hint"
  [emptyStateTitle]="emptyStateTitle"
  [emptyStateDescription]="emptyStateDescription"
  (filesSelected)="onFilesSelected($event)"
  (removeRequested)="removeFile($event)"></app-file-uploader-base>
